
/* injects from baggage-loader */

import React, { Component } from "react";
import { getCompetitionsSubscriptionRequest } from "../../../helpers/terminalRequests/virtualSportsHelpers";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import PropTypes from "prop-types";
import Loader from "../loader/index";
import Helpers from "../../../helpers/helperFunctions";
import VirtualGamesList from "../virtualGamesList";
import { t } from "../../../helpers/translator";

class VirtualGamesCompetitions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCompetitionIndex: 0,
		};
		this.selectCompetition = this.selectCompetition.bind(this);
	}

	selectCompetition(selectedCompetitionIndex) {
		return () => this.setState({ selectedCompetitionIndex });
	}

	render() {
		let { data, loaded, providerId } = this.props,
			{ selectedCompetitionIndex } = this.state,
			selectedCompetitionId = data && data[this.state.selectedCompetitionIndex].id;
		if (data && loaded) {
			return [
				<div className="competition-name-w" key={"container"}>
					<h2>{t("Competitions")}</h2>
				</div>,
				<ul className={"virtual-games-competition-wrapper"} key={"wrapper"}>
					{data.map((competition, i) => {
						return (
							<li key={competition.id} onClick={this.selectCompetition(i)}>
								<span
									className={
										selectedCompetitionIndex === i
											? "active"
											: ""
									}
								>
									<i>{competition.name}</i>
								</span>
							</li>
						);
					})}
				</ul>,
				<VirtualGamesList
					competitionId={selectedCompetitionId}
					key={selectedCompetitionId}
					providerId={providerId}
				/>,
			];
		} else {
			return <Loader component="virtualGamesCompetitions" />;
		}
	}
}

VirtualGamesCompetitions.propTypes = {
	sportId: PropTypes.number,
	providerId: PropTypes.number,
	data: PropTypes.array,
	loaded: PropTypes.bool,
};

const mapStateToProps = (_, ownParams) => {
	let key = getSwarmDataKeyForRequest(getCompetitionsSubscriptionRequest(ownParams.sportId));
	return createSelector(
		[
			state => state.swarmData.loaded[key],
			state =>
				state.swarmData.data[key] &&
				JSON.stringify(Helpers.objectToArray(state.swarmData.data[key].competition)),
		],
		(loaded, data) => {
			data = data && JSON.parse(data);
			return {
				data,
				loaded,
			};
		}
	);
};

export default connect(mapStateToProps)(
	SwarmDataMixin({
		Component: VirtualGamesCompetitions,
		ComponentWillMount: function () {
			let { sportId } = this.props;
			this.swarmSubscriptionRequest = getCompetitionsSubscriptionRequest(sportId);
			this.swarmDataKey = getSwarmDataKeyForRequest(getCompetitionsSubscriptionRequest(sportId));
		},
	})
);
